import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import Checkbox from '@component/form/element/checkbox';
import FormNotification from '@component/form/element/formnotification';

const TermsOfService = ({ termsOfService, onTermsChange, getErrorMessage }) => {
  return (
    <React.Fragment>
      <Checkbox
        label={I18n.t('form.account.terms_conditions', {
          options: 'tabindex="-1" data-route-context="plus"',
        })}
        name="terms_of_service"
        onChange={onTermsChange}
        checked={termsOfService}
      />
      <FormNotification
        message={getErrorMessage('terms_of_service')}
        type="error"
      />
    </React.Fragment>
  );
};

TermsOfService.propTypes = {
  termsOfService: PropTypes.bool.isRequired,
  onTermsChange: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
};

export default TermsOfService;
